// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let CustodialData = function ()
{
    this.InstrumentGroupId = null;
    this.InstrumentId = "";
    this.Fee = 0;
    this.Measure = 0;
    // this.FormattedValue = ""
}

CustodialData.prototype.FormattedValue = function ()
{
    return this.Fee + " " + CustodialMeasure.descriotionMap[this.Measure];
}

export let CustodialMeasure =
{
    BasisPoint: 0 //bp
}
CustodialMeasure.descriotionMap = { 0: "bp" }
